module.exports = __webpack_public_path__ + "img/4.928b28b0.svg";